var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#C4314B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.66667L9.66662 11L13.6665 14.9999L9.66653 18.9999L10.9999 20.3332L14.9999 16.3332L18.9999 20.3333L20.3333 19L16.3332 14.9999L20.3332 10.9999L18.9999 9.66658L14.9999 13.6666L11 9.66667Z",
    fill: "#FCF4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteRed);
export default __webpack_public_path__ + "static/media/Icon_Delete_Red.cf7ac01273d44ba222608367d3374440.svg";
export { ForwardRef as ReactComponent };